import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { ServiceUnavailableScreenService } from '../services/service-unavailable-screen.service';
import { ConnectionUnavailableScreenService } from '../services/connection-unavailable-screen.service';

export const serviceUnavailableInterceptor: HttpInterceptorFn = (req, next) => {
  const serviceUnavailableScreenService = inject(
    ServiceUnavailableScreenService
  );
  const connectionUnavailableScreenService = inject(
    ConnectionUnavailableScreenService
  );

  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        serviceUnavailableScreenService.hideServiceUnavailable();
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (serviceUnavailableScreenService.isServiceUnavailableError(error)) {
        connectionUnavailableScreenService.hideConnectionUnavailable();
        serviceUnavailableScreenService.showServiceUnavailable();
      }

      return throwError(() => error);
    })
  );
};
